import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  const mdBreakpoint = '@media (min-width: 750px)';
  const lgBreakpoint = '@media (min-width: 1000px)';

  return {
    card: {
      '&:last-child $hrContainer': {
        display: 'none',
      },
      [lgBreakpoint]: {
        minWidth: '1047px',
        width: '1047px',
      },
      maxWidth: '800px',
      padding: '24px 16px 24px 20px',
      border: '0.25px solid #78AEB3',
      borderTopRightRadius: '20px',
      borderBottomLeftRadius: '20px',
      boxShadow: '0px 4px 20px 0px #00000040',
      marginBottom: '20px',
    },
    indexContainer: {
      marginTop: '6px',
      fontFamily: 'Poppins',
      fontSize: '20px',
      fontWeight: '500',
      lineHeight: '22px',
      letterSpacing: '2%',
      textAlign: 'left',
      color: '#2E2E2E',
      width: '25px',
      marginRight: '20px',
      [mdBreakpoint]: {
        width: '49px',
      }
    },
    infoContainer: {
      display: 'flex',
      flexDirection: 'column',
      margin: '0px',
      padding: '0px',
    },
    keyAndValueRow: {
      display: 'flex',
      margin: '0px',
      padding: '0px',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    row: {
      display: 'flex',
      flexDirection: 'column', // For smaller screens, stack items vertically
      margin: '0px',
      padding: '0px',
      [lgBreakpoint]: {  // For larger screens, change to row layout
        flexDirection: 'row',
      },
    },
    column: {
      flex: 1,
      margin: '0px',
      padding: '0px',
      [lgBreakpoint]: {  // For larger screens, allow for two columns
        flexBasis: '50%',
      },
    },
    leftColumn: {
      [lgBreakpoint]: { 
        marginLeft: '20px',
      },
    },
    titleRow: {
      marginBottom: '5px',
    },
    titleKey: {
      margin: '0px',
      padding: '2px 15px 2px 15px',
      gap: '10px',
      fontFamily: 'Poppins',
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '19.31px',
      letterSpacing: '0px',
      color: 'white',
      height: '30px',
      display: 'flex',
      borderRadius: '20px',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#5F70CB',
    },
    titleValue: {
      margin: '0px',
      padding: '0px',
      marginTop: '2px',
      marginLeft: '10px',
      fontFamily: 'Inter',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '22px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: '#00838F',
    },
    key: {
      fontFamily: 'Inter',
      fontSize: '14.25px',
      fontWeight: '600',
      lineHeight: '22px',
      letterSpacing: '2.25%',
      textAlign: 'left',
      margin: '0px 0px 0px 3px',
      padding: '0px',
      textTransform: 'uppercase',
      color: '#0F757E',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    },
    value: {
      fontFamily: 'Inter',
      fontSize: '16px',
      fontWeight: '400px',
      lineHeight: '22px',
      letterSpacing: '2%',
      textAlign: 'left',
      margin: '0px',
      paddingLeft: '15px',
      wordBreak: 'break-word',
    },
    propertyLine: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      margin: '0px',
      padding: '0px',
      position: 'relative',
      width: '100%',
    },
    expandableValueContainer: {
      paddingLeft: '15px',
      flex: 1,
      minWidth: 0,
      paddingRight: '30px',
      lineHeight: '22px',
      [mdBreakpoint]: {
        paddingRight: '35px',
      },
      '@media (max-width: 600px)': {
        paddingLeft: '8px',
        paddingRight: '28px',
      },
    },
    expandableTextContainer: {
      width: '100%',
      minWidth: 0,
    },
    expandableValueCollapsed: {
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: '0 !important',
      maxWidth: '100%',
    },
    expandableValueExpanded: {
      display: 'inline',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      paddingLeft: '0 !important',
    },
    expandToggle: {
      cursor: 'pointer',
      position: 'absolute',
      top: '2px',
      right: '20px',
      display: 'flex',
      alignItems: 'flex-start',
      '&:hover': {
        opacity: '0.7',
      },
      '@media (max-width: 600px)': {
        top: '2px',
        right: '0px',
      },
    },
    expandIcon: {
      fontSize: '18px',
      color: '#000000',
      '@media (max-width: 600px)': {
        fontSize: '16px',
      },
    },
    clickableText: {
      cursor: 'pointer',
      '&:hover': {
        opacity: '0.7',
      },
    },
    hrContainer: {
      paddingTop: '10px',
      paddingBottom: '10px',
      maxWidth: '800px',
      marginLeft: '18px',
      [mdBreakpoint]: {
        marginLeft: '36px',
      },
      [lgBreakpoint]: {
        marginLeft: '36px',
        width: '925px',
        minWidth: '925px',
      },
    },
    hr: {
      width: '100%', 
      border: '1px solid #E7EEF5',
      margin: '10px 0px',
      padding: '0px',
    },
    button: {
      width: '189px',
      height: '41px',
      alignSelf: 'end',
      color: '#07679C',
      borderColor: '#07679C',
      fontFamily: 'Poppins',
      fontWeight: '600',
      fontSize: '12px',
      marginTop: '20px',
      lineHeight: '13px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0 12px',
      borderRadius: '8px',
      transition: 'border-radius 0.2s ease-in-out',
      '&:hover': {
        backgroundColor: '#DEE4EC',
      },
      '& .MuiButton-label': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      },
    },
    cardHeader: {
      marginBottom: '8px',
    },
    titleContainer: {
      flex: 1,
      width: '100%',
    },
    buttonAlignWithTitle: {
      marginTop: '-20px', // Move button up to align with title baseline
    },
    customTooltip: {
      backgroundColor: '#ffffff',
      color: '#000000',
      border: '1px solid #000000',
      fontSize: '14px',
      fontFamily: 'Inter',
      padding: '12px 16px',
      borderRadius: '4px',
      maxWidth: '400px',
      wordWrap: 'break-word',
      lineHeight: '1.4',
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
    },
    customTooltipArrow: {
      color: '#000000',
      '&:before': {
        backgroundColor: '#ffffff',
        border: '1px solid #000000',
      },
    },
  }
});

export default useStyles;
